import { themed } from "@smartsheet/sds-theme-internal";
const buttonHeightTheme = themed({
  large: 40,
  medium: 32,
  small: {
    "lodestar-light": 24,
    "ursa-light": 28
  },
  xsmall: 20
});
export const getButtonHeight = _ref => {
  let {
    size,
    themeMode
  } = _ref;
  return buttonHeightTheme[size](themeMode);
};
//# sourceMappingURL=getButtonHeight.js.map